/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { File } from '../../models/file';
import { ImportResponseList } from '../../models/import-response-list';

export interface ApiMessageCsvPost$Params {
      body: File
}

export function apiMessageCsvPost(http: HttpClient, rootUrl: string, params: ApiMessageCsvPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ImportResponseList>> {
  const rb = new RequestBuilder(rootUrl, apiMessageCsvPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ImportResponseList>;
    })
  );
}

apiMessageCsvPost.PATH = '/api/message/csv';
